import { useGetCurrentBoard } from 'entities/board/api/hooks/useGetCurrentBoard';
import { getHasHateoasAccess } from 'helpers';

export const useCanListTemplates = () => {
  const { board } = useGetCurrentBoard();

  return getHasHateoasAccess('templates', board?.__links);
};
